import type { DashboardPeriod } from '~/app/services/organization-manager-dashboard/organization-manager-dashboard.types';
import type {
  GetOperationsKpisResponseDto,
  OperationsQuarterCode,
} from './operations-kpi.types';

/** Stand-in payload until the operations KPI API is on main. */
export const OPERATIONS_KPIS_MOCK: GetOperationsKpisResponseDto = {
  accountability: {
    slaComplianceRatePercent: 92.8,
    compliantSiteCount: 26,
    siteCount: 28,
    activeBreachCount: 2,
    totalPenaltyEuros: null,
    breachSites: [
      { id: 'horizon-mall', siteName: 'Horizon Mall', status: 'breach' },
      { id: 'commune-e', siteName: 'Commune E', status: 'breach' },
    ],
  },
  repairHours: {
    quarters: [
      { quarter: 'Q4', year: 2025, hours: 12, highlighted: false },
      { quarter: 'Q1', year: 2026, hours: 10, highlighted: false },
      { quarter: 'Q2', year: 2026, hours: 14, highlighted: true },
      { quarter: 'Q3', year: 2026, hours: 9.4, highlighted: false },
    ],
    currentHours: 9.4,
    peakHours: 14,
    targetHours: 4,
  },
};

function quarterForPeriod(
  period: DashboardPeriod,
): OperationsQuarterCode | null {
  switch (period) {
    case 'q1-2026':
      return 'Q1';
    case 'q2-2026':
      return 'Q2';
    case 'q3-2026':
      return 'Q3';
    case 'q4-2026':
      return 'Q4';
    case 'last-12-months':
      return null;
  }
}

function breachCountForPeriod(period: DashboardPeriod): number {
  switch (period) {
    case 'q1-2026':
      return 3;
    case 'q2-2026':
      return 2;
    case 'q3-2026':
      return 2;
    case 'q4-2026':
      return 1;
    case 'last-12-months':
      return 4;
  }
}

export function operationsKpisForPeriod(
  period: DashboardPeriod,
): GetOperationsKpisResponseDto {
  const kpis = structuredClone(OPERATIONS_KPIS_MOCK);
  const selectedQuarter = quarterForPeriod(period);

  kpis.accountability.activeBreachCount = breachCountForPeriod(period);
  kpis.repairHours.quarters = kpis.repairHours.quarters.map((quarter) => ({
    ...quarter,
    highlighted:
      selectedQuarter != null ? quarter.quarter === selectedQuarter : false,
  }));
  kpis.repairHours.currentHours = selectedQuarter
    ? (kpis.repairHours.quarters.find(
        (quarter) => quarter.quarter === selectedQuarter,
      )?.hours ?? kpis.repairHours.currentHours)
    : kpis.repairHours.currentHours;

  return kpis;
}
